// extracted by mini-css-extract-plugin
export default {"groupHeader":"H3ZSpCREhSAOVgdRiC29"};